import React from 'react'
import { TitleProps } from '@pankod/refine-core'
import { Tooltip, Typography } from '@pankod/refine-antd'
import Link from 'next/link'
import _ from 'lodash'
import Cookies from 'js-cookie'

import { BASE_PATH, SESSION } from 'src/constant'

const { Title: AntDTitle } = Typography

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const userSession = Cookies.get(SESSION.USER_SESSION)
  const lmsRole = userSession ? JSON.parse(userSession).user.LMSRole : ''

  return (
    <Link href="/">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`${BASE_PATH}/logogram.svg`}
          alt="logo"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '12px 20px',
            height: '64px',
          }}
        />
        <div className="flex flex-col justify-center" suppressHydrationWarning>
          <AntDTitle
            level={3}
            style={{
              margin: '0',
              flexShrink: 0,
              display: collapsed ? 'none' : 'initial',
            }}
          >
            LMS Admin
          </AntDTitle>
          {lmsRole && !collapsed && (
            <Tooltip title={_.startCase(lmsRole)} placement="right">
              <Typography.Text
                type="secondary"
                className="italic !max-w-[130px]"
                ellipsis
              >
                {_.startCase(lmsRole)}
              </Typography.Text>
            </Tooltip>
          )}
        </div>
      </div>
    </Link>
  )
}
